// utils/urlValidator.ts
interface UrlValidationOptions {
    allowedProtocols?: string[]
    allowedHostnames?: string[]
    allowLocalhost?: boolean
    allowedBuckets?: string[]
    requireObjectKey?: boolean
}

export const validateUrl = (url: string, options: UrlValidationOptions = {}): string | null => {
    const {
        allowedProtocols = ['https:'],
        allowedHostnames = [
            's3.amazonaws.com',
            's3.eu-north-1.amazonaws.com',
            's3.eu-west-1.amazonaws.com',
            's3.us-east-1.amazonaws.com',
        ],
        allowLocalhost = process.env.NODE_ENV !== 'production',
        allowedBuckets = [],
        requireObjectKey = false,
    } = options

    try {
        const parsedUrl = new URL(url)

        if (!allowedProtocols.includes(parsedUrl.protocol)) {
            console.error(`Недозволений протокол: ${parsedUrl.protocol}`)
            return null
        }

        const isHostnameAllowed = allowedHostnames.some(
            (hostname) => parsedUrl.hostname === hostname || parsedUrl.hostname.endsWith(`.${hostname}`)
        )

        if (!isHostnameAllowed) {
            console.error(`Недозволений hostname: ${parsedUrl.hostname}`)
            return null
        }

        const s3Hostnames = [
            's3.amazonaws.com',
            's3.eu-north-1.amazonaws.com',
            's3.eu-west-1.amazonaws.com',
            's3.us-east-1.amazonaws.com',
        ]

        const isS3Hostname = s3Hostnames.some(
            (hostname) => parsedUrl.hostname === hostname || parsedUrl.hostname.endsWith(`.${hostname}`)
        )

        let canonicalPathname = parsedUrl.pathname

        if (isS3Hostname) {
            const pathParts = parsedUrl.pathname.split('/').filter(Boolean)

            if (pathParts.length === 0) {
                console.error('S3 URL не містить бакету')
                return null
            }

            const [bucket, ...keyParts] = pathParts
            console.log(bucket, keyParts)

            if (allowedBuckets.length > 0 && !allowedBuckets.includes(bucket)) {
                console.error(`Бакет не дозволений: ${bucket}`)
                return null
            }

            if (/[\\/?#]/.test(bucket)) {
                console.error('Недопустимі символи в імені бакету')
                return null
            }

            const objectKey = keyParts.join('/')

            if (requireObjectKey && !objectKey) {
                console.error("Відсутній ключ об'єкту в S3 URL")
                return null
            }

            if (
                objectKey &&
                objectKey.split('/').some((segment) => segment === '..' || segment === '' || /[\\?#]/.test(segment))
            ) {
                console.error('Path traversal або недопустимі символи не дозволені в S3 URL')
                return null
            }

            canonicalPathname = `/${bucket}${objectKey ? '/' + objectKey : ''}`
        }

        if (!allowLocalhost && (parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1')) {
            console.error('localhost не дозволений')
            return null
        }

        const origin = parsedUrl.origin
        const search = parsedUrl.search || ''

        return `${origin}${canonicalPathname}${search}`
    } catch (error) {
        console.error('Помилка парсингу URL:', error)
        return null
    }
}

export const validateS3Url = (url: string, allowedBuckets?: string[]): string | null => {
    return validateUrl(url, {
        allowedProtocols: ['https:'],
        allowedHostnames: [
            's3.amazonaws.com',
            's3.eu-north-1.amazonaws.com',
            's3.eu-west-1.amazonaws.com',
            's3.us-east-1.amazonaws.com',
        ],
        allowLocalhost: false,
        allowedBuckets: allowedBuckets || [],
        requireObjectKey: true,
    })
}
